import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';

import { SegmentValidationItem } from './segment-validation-item.interface';
import { SegmentValidationService } from './segment-validation.service';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'segment-validation',
  templateUrl: 'segment-validation.component.html',
  styleUrls: ['segment-validation.component.scss'],
})
export class SegmentValidationComponent implements OnInit, OnDestroy {
  model: any = {};

  @Input() validationTitle: string = 'Validation';
  @Input() showEntryDetail: boolean = false;

  private isActive: boolean = true;

  constructor(
    private segmentValidationService: SegmentValidationService,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.model = this.segmentValidationService.model;
    this.segmentValidationService.setDataEvent
    .pipe(takeWhile(() => this.isActive))
    .subscribe((model: any) => {
      this.ref.markForCheck();
    });
  }

  ngOnDestroy() {
    this.isActive = false;
    this.model = {};
    this.segmentValidationService.resetValidation();
  }

}
